import React from "react";
import { Link, useHistory } from "react-router-dom";
import Slider from "react-slick";
import ImgPlaceHolder from "../../constant/imgPlaceholder";
import { ROUTE } from "../../route/Route";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import SectionLoader from "../../Component/LodingScreen/SectionLoader";
import { useSelector } from "react-redux";

function Testimonial(props: any) {
  const { t } = useTranslation();
  const { testimonial } = props;
  const history = useHistory();
  const loadingData_New: any = props?.loadingData || null;
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: testimonial && testimonial?.length == 1 ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <div>
        <section className="section tesi-wrap tesi-wrap-pb" style={{width: "100%"}}>
          <div className="container">
            <div className="row testi-mo d-flex justify-content-center align-items-center">
              <div className="d-flex justify-content-between align-items-center" style={{width: "96%"}}>
                <div className="">
                  <div className="headingmains testi-mo-pad">
                    <h2>{t("testimonials")}</h2>
                    <p>{t("testimonial_content")}</p>
                  </div>
                </div>
                
              </div>
              <div className="col-md-7">
                {/* <div className="exploretesti">
                  <a
                    href="#"
                    onClick={(e: any) => {
                      e.preventDefault();
                      history.push(ROUTE.TESTIMONIAL, { type: 1 });
                    }}
                  >
                    {t("explore_all")}
                  </a>
                </div> */}
              </div>

              
            </div>
            <div className="row">
              {/* <div className="col-md-5 col-sm-6">
                <div className="inner-heading">
                  <div className="headingmains">
                    <p>{t("testimonial_content")}</p>
                  </div>
                </div>
              </div> */}
              <div className="col-md-12 col-sm-6">
                {loadingData_New && Object.keys(loadingData_New)?.length > 0 ? (
                  <>
                    {testimonial && testimonial.length > 0 && (
                      <div className="testi_slider">
                        <Slider {...settings}>
                          {testimonial &&
                            testimonial?.length > 0 &&
                            testimonial?.map((item: any, index: any) => (
                              <div key={index}>
                                <div className="col-md-12 col-sm-12 col-xs-12 item">
                                  <div className="team_member">
                                    <figure className="effect-julia">
                                      <img
                                        src={
                                          item?.ProfileImage
                                            ? item?.ProfileImage
                                            : item?.Gender &&
                                              item?.Gender?.toLowerCase() ==
                                                "female"
                                            ? "/assets/img/testi_female.png"
                                            : "/assets/img/testi_male.png"
                                        }
                                        onError={(e: any) =>
                                          ImgPlaceHolder(
                                            e,
                                            item?.Gender &&
                                              item?.Gender?.toLowerCase() ==
                                                "female"
                                              ? "/assets/img/testi_female.png"
                                              : "/assets/img/testi_male.png"
                                          )
                                        }
                                        alt=""
                                      />
                                    </figure>
                                    <div className="member_name">
                                      <p
                                        className="truncate"
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.Content &&
                                            item?.Content?.slice(0, 300),
                                        }}
                                      ></p>
                                      {item?.VideoUrl && (
                                        <p>
                                          <ReactPlayer
                                            className="testimonialVdo"
                                            controls
                                            url={item?.VideoUrl}
                                          />
                                        </p>
                                      )}
                                      <h5>
                                        <span></span>
                                        {item?.Name}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </Slider>
                      </div>
                    )}
                  </>
                ) : (
                  <SectionLoader />
                )}
              </div>
            </div>

             <div className="exploretesti">
                  <a
                    href="#"
                    onClick={(e: any) => {
                      e.preventDefault();
                      history.push(ROUTE.TESTIMONIAL, { type: 1 });
                    }}
                  >
                    {t("explore_all")}
                  </a>
                </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default React.memo(Testimonial);
